import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { isFirstPage } from 'utils/helpers';
import MarketingCard from './marketing-card';

const MarketingCards = ({ cards, view }) => {
  const cardElements = useRef([]);

  const [cardsInjected, setCardsInjected] = useState(false);

  const cardsConfig =
    view === '3 Large'
      ? {
          positions: [8, 26, 40],
          sizes: ['large', 'large', 'large'],
        }
      : {
          positions: [4, 12, 23, 34, 45],
          sizes: ['large', 'small', 'small', 'small', 'small'],
        };

  useEffect(() => {
    const injectCards = async () => {
      if (cardsInjected) return;
      // eslint-disable-next-line arrow-body-style
      const eventDispatcher = () => {
        return new Promise((resolve) => {
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('marketingCardsReady'));
          }, 0);
          resolve();
        });
      };
      const ssContainer = document.querySelector('.ss__results');
      const tmwContainer = document.getElementById('product-grid');

      const productCards = document.querySelectorAll('.product-card');
      const ssResults = document.querySelectorAll('.ss__result');
      const container = ssContainer || tmwContainer;
      const productCardsLoaded = productCards.lenth > 0 || ssResults.length > 0;

      if (container && isFirstPage() && productCardsLoaded) {
        container
          .querySelectorAll('.marketing-card')
          .forEach((element) => element.remove());
        const { positions } = cardsConfig;
        const callbacks = [];

        container.childNodes.forEach((element, index) => {
          const cardIndex = positions.indexOf(index);
          if (cardIndex >= 0 && cards[cardIndex]) {
            // eslint-disable-next-line arrow-body-style
            callbacks.push(() => {
              return new Promise((resolve) => {
                container.insertBefore(
                  cardElements.current[cardIndex].base.cloneNode(true),
                  element,
                );
                resolve();
              });
            });
          }
        });

        callbacks.push(eventDispatcher);
        callbacks.forEach(async (callback) => {
          await callback();
        });
      } else if (container && productCardsLoaded) {
        container
          .querySelectorAll('.marketing-card')
          .forEach((element) => element.remove());
        document.dispatchEvent(new CustomEvent('marketingCardsReady'));
      }

      setCardsInjected(true);
    };
    injectCards();
    document.addEventListener('swym:collections-loaded', injectCards);
    return () => {
      document.removeEventListener('swym:collections-loaded', injectCards);
    };
  }, []);

  return (
    <div className="hidden">
      {cards.map((item, index) => (
        <MarketingCard
          key={index}
          {...item}
          size={cardsConfig.sizes[index]}
          ref={(element) => {
            cardElements.current[index] = element;
          }}
        />
      ))}
    </div>
  );
};

export default MarketingCards;
